module.exports = __webpack_public_path__ + "static/media/ally_pro_7.72123fe1.jpg";